import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetHospitalSelectors } from '../types';

const onGetHospitalSelectors: IThunkGetHospitalSelectors = thunk(
  // @ts-ignore
  async ({ setHospitalSelectors }) => {
    const data = await api.hospital.getSelectors().then(res => res.data);

    setHospitalSelectors(data);
  },
);

export default onGetHospitalSelectors;
